import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import * as _ from 'lodash';

import { CONSTANT_VALUES } from '../constants/constant-values';
import { AppService } from '../app.service';
import { HttpInterceptor } from '../shared/index';
import { environment } from '../../environments/environment';
import { Member } from './member';
import { MemberList } from './member-list';
import { CONSTANT_MESSAGES } from '../constants/constants-messages';
import { UtilityFunctions } from '../shared/utility-functions';

@Injectable()
export class MemberService {
    private _appService;
    private utilityFunctions = new UtilityFunctions();
    constructor(private http: HttpInterceptor, private appService: AppService) {
        this._appService = appService;
    }
    /**
     *  Add member from portal 
     * 
     * @param {MemberList} memberObject 
     * @returns 
     * 
     * @memberOf MemberService
     */
    addMember(memberObject: MemberList) {
        try {
            let url = CONSTANT_VALUES.URL_ADD_MEMBER;
            return new Promise((resolve, reject) => {
                this.http.post(url, memberObject).map((res) => res.json()).subscribe(data => {
                    resolve(data);
                });
            });
        } catch (e) {
            console.log(e);
        }
    }
    /**
     * Validate member fields
     * 
     * @param {any} member 
     * @returns 
     * 
     * @memberof MemberService
     */
    validationViewSide(member) {
        try {
            let response = {
                status: 200,
                message: ''
            };
            if (member != null) {
                if (member.emailId === '') {
                    response.status = 203;
                    response.message = CONSTANT_MESSAGES.REQUIRE_EMAIL_ID;

                    return response;
                }
                if (member.contactNumber == null || member.contactNumber === '') {
                    response.status = 204;
                    response.message = CONSTANT_MESSAGES.REQUIRE_CONTACT_NUMBER;
                    return response;
                }
                if (member.membershipId === '') {
                    response.status = 205;
                    response.message = CONSTANT_MESSAGES.REQUIRE_MEMBERSHIP_ID;
                    return response;
                }
            } else {
                response.status = 206;
                response.message = CONSTANT_MESSAGES.REQUIRE_MEMBER_OBJECT;
                return response;
            }
            return response;
        } catch (e) {
            console.log(e);
        }
    }
    /**
     * Add multiple member from file
     * 
     * @param {any} input 
     * @returns 
     * 
     * @memberOf MemberService
     */
    getMembersFromFile(input) {
        try {
            let that = this;
            let file = input.files[0];
            let lines: any;
            let members = [];
            return new Promise((resolve, reject) => {
                if (file && file.name.indexOf('csv') !== -1) {
                    let reader = new FileReader();
                    reader.onload = function () {
                        let text = reader.result;
                        lines = text.split(/\r?\n/);
                        lines.forEach(function (line, i) {
                            if (line !== '') {
                                let lineObj = line.split(',');
                                let obj = {
                                    emailId: lineObj[0] ? lineObj[0].trim() : '',
                                    contactNumber: lineObj[1] ? lineObj[1].trim() : '',
                                    membershipId: lineObj[2] ? lineObj[2].trim() : '',
                                    firstName: lineObj[3] ? lineObj[3].trim() : '',
                                    lastName: lineObj[4] ? lineObj[4].trim() : '',
                                    type: lineObj[5] ? lineObj[5].trim() : ''
                                };
                                if (that.validateMandetoryFields(obj, members)) {
                                    members.push(obj);
                                }
                                if (i <= (lines.length - 1)) {
                                    resolve(members);
                                }
                            } else {
                                resolve([]);
                            }
                        });
                    };
                    reader.readAsText(file);
                } else {
                }
            });
        } catch (e) {
            console.log(e);
        }
    }

    hasMemberWithDuplicateContactNumber(contactNumber, members) {
        return _.find(members, { contactNumber: contactNumber });
    }
    /**
     * Validate member object fields
     * 
     * @param {any} rec 
     * @param {any} members 
     * @returns 
     * 
     * @memberOf MemberService
     */
    validateMandetoryFields(rec, members) {
        try {
            let validate = true;
            if (!(rec.membershipId + '').trim()) {
                validate = false;
            } else if (!(this.utilityFunctions.validateEmail(rec.emailId))) {
                validate = false;
            } else if (this.utilityFunctions.validateContact(rec.contactNumber) || !(rec.contactNumber + '').trim() ||
                rec.contactNumber.length < 4 || rec.contactNumber.length > 16) {
                validate = false;
            } else if (members.length && this.hasMemberWithDuplicateContactNumber(rec.contactNumber, members)) {
                validate = false;
            } else if (!rec.firstName || !(rec.firstName + '').trim()) {
                validate = false;
            } else if (!rec.lastName || !(rec.lastName + '').trim()) {
                validate = false;
            } else {
                if ((rec.type + '').trim().toLowerCase() === 'tenant') {
                    rec.type = 'Tenant';
                } else if ((rec.type + '').trim().toLowerCase() === 'owner') {
                    rec.type = 'Owner';
                } else {
                    validate = false;
                }
            }
            return validate;
        } catch (e) {
            console.log(e);
        }
    }

    /**
     * Delete member from condo.
     * 
     * @param {any} vendorObject 
     * @returns 
     * 
     * @memberOf MemberService
     */
    deleteMember(vendorObject) {
        try {
            let url = CONSTANT_VALUES.URL_DELETE_USER;
            return new Promise((resolve, reject) => {
                this.http.post(url, vendorObject).map((res) => res.json()).subscribe(data => {
                    resolve(data);
                });
            });
        } catch (e) {
            console.log(e);
        }
    }
    /**
     * Disable member for specific facility
     * 
     * @param {any} disableMemberObj 
     * @returns 
     * 
     * @memberOf MemberService
     */
    disableMemberForSpecificFacility(disableMemberObj) {
        try {
            let url = CONSTANT_VALUES.URL_DISABLE_MEMBER;
            return new Promise((resolve, reject) => {
                this.http.post(url, disableMemberObj).map((res) => res.json()).subscribe(data => {
                    resolve(data);
                });
            });
        } catch (e) {
            console.log(e);
        }
    }
    /**
     * Update member details  which are at vendor side
     * 
     * @param {any} vendorObject 
     * @returns 
     * 
     * @memberOf MemberService
     */
    updateMember(vendorObject) {
        try {
            let url = CONSTANT_VALUES.URL_UPDATE_MEMBER;
            return new Promise((resolve, reject) => {
                this.http.post(url, vendorObject).map((res) => res.json()).subscribe(data => {
                    resolve(data);
                });
            });
        } catch (e) {
            console.log(e);
        }
    }

    /**
     * Resend unique code
     * 
     * @param {any} vendorObject 
     * @returns 
     * 
     * @memberOf MemberService
     */
    resendMail(vendorObject) {
        try {
            let url = CONSTANT_VALUES.URL_RESEND_CODE;
            return new Promise((resolve, reject) => {
                this.http.post(url, vendorObject).map((res) => res.json()).subscribe(data => {
                    resolve(data);
                });
            });
        } catch (e) {
            console.log(e);
        }
    }
    /**
     * Deactivate member service call
     * 
     * @param {any} vendorObject 
     * @returns 
     * 
     * @memberOf MemberService
     */
    makeDeactive(vendorObject) {
        try {
            let url = CONSTANT_VALUES.URL_DEACTIVATE_USER;
            return new Promise((resolve, reject) => {
                this.http.post(url, vendorObject).map((res) => res.json()).subscribe(data => {
                    resolve(data);
                });
            });
        } catch (e) {
            console.log(e);
        }
    }
    /**
     * Enable members for multiple facility API call
     * 
     * @param {any} enableObj 
     * @returns 
     * 
     * @memberOf MemberService
     */
    enableMembers(enableObj) {
        try {
            let url = CONSTANT_VALUES.URL_ENABLE_MEMBER;
            let _userIds = [];
            enableObj.userIds.forEach((userId) => {
                if (typeof userId === 'string') {
                    _userIds.push(userId);
                }
            });
            enableObj.userIds = _userIds;
            return new Promise((resolve, reject) => {
                this.http.post(url, enableObj).map((res) => res.json()).subscribe(data => {
                    resolve(data);
                });
            });
        } catch (e) {
            console.log(e);
        }
    }
    /**
     * Get vendor details
     * 
     * @param {any} vendorObject 
     * @returns 
     * 
     * @memberOf MemberService
     */
    getVendorDetails(vendorObject) {
        try {
            let url = CONSTANT_VALUES.URL_GET_VENDOR_BY_ID;
            return new Promise((resolve, reject) => {
                this.http.post(url, vendorObject).map((res) => res.json()).subscribe(data => {
                    resolve(data);
                });
            });
        } catch (e) {
            console.log(e);
        }
    }
    /**
     * Get active member list
     * 
     * @param {any} vendorObject 
     * @returns 
     * 
     * @memberOf MemberService
     */
    markActiveToMember(vendorObject) {
        try {
            let url = CONSTANT_VALUES.URL_GET_ACTIVATE_USER;
            return new Promise((resolve, reject) => {
                this.http.post(url, vendorObject).map((res) => res.json()).subscribe(data => {
                    resolve(data);
                });
            });
        } catch (e) {
            console.log(e);
        }
    }
    /**
     * Get deactivate users
     * 
     * @param {any} vendorObject 
     * @returns 
     * 
     * @memberOf MemberService
     */
    markDeactiveToMember(vendorObject) {
        try {
            let url = CONSTANT_VALUES.URL_GET_DEACTIVATE_USER;
            return new Promise((resolve, reject) => {
                this.http.post(url, vendorObject).map((res) => res.json()).subscribe(data => {
                    resolve(data);
                });
            });
        } catch (e) {
            console.log(e);
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/member/member.service.ts